import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { Button } from "@circle-react-shared/uikit/Button";
import { Dropdown } from "@circle-react-shared/uikit/Dropdown";

interface FormWrapperFooterProps {
  isPageLoading: boolean;
  onDiscard: () => void;
  onUpdatePageTheme: () => void;
  onUpdateSiteTheme: () => void;
}

export const FormWrapperFooter = ({
  isPageLoading,
  onDiscard,
  onUpdatePageTheme,
  onUpdateSiteTheme,
}: FormWrapperFooterProps) => (
  <>
    <Button variant="secondary" onClick={onDiscard} disabled={isPageLoading}>
      {t("builder_ui.theme_configuration.themes_list.discard")}
    </Button>
    <div className="flex space-x-px">
      <Button
        variant="circle"
        className="rounded-r-none"
        onClick={onUpdatePageTheme}
        disabled={isPageLoading}
      >
        {t("builder_ui.theme_configuration.update_page_theme")}
      </Button>
      <Dropdown
        popperOptions={{
          placement: "top-end",
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, 10],
              },
            },
          ],
        }}
        button={
          <Button
            variant="circle"
            className="flex h-8 items-center justify-center rounded-l-none pl-1 pr-1.5"
          >
            <Icon size={16} type="16-chevron-down" />
          </Button>
        }
      >
        <Dropdown.ItemWithLink onClick={onUpdateSiteTheme}>
          {t("builder_ui.theme_configuration.update_site_theme")}
        </Dropdown.ItemWithLink>
      </Dropdown>
    </div>
  </>
);
